import { render, staticRenderFns } from "./StudentGraduation.vue?vue&type=template&id=1d90f798&scoped=true&"
import script from "./StudentGraduation.vue?vue&type=script&lang=js&"
export * from "./StudentGraduation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d90f798",
  null
  
)

export default component.exports